import {
    GET_ALL_USERS,
    GET_REQUIRED_QUALIFICATIONS,
    GET_QUALIFICATION_CATEGORIES,
    SET_VIEW_CATEGORY_DETAILS,
} from "./types";

const INITIAL_STATE = {
    requesting: true,
    users: false,
    qualifications: false,
    qualificationCategories: false,
    viewCategoryModalInfo: {
        category: false,
        modalOpen: false
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_ALL_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_ALL_USERS.SUCCESS: {
            return { ...state, requesting: true, users: action.payload };
        }
        case GET_REQUIRED_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, qualifications: false };
        }
        case GET_REQUIRED_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, qualifications: false };
        }
        case GET_REQUIRED_QUALIFICATIONS.SUCCESS: {
            return { ...state, requesting: false, qualifications: action.payload };
        }
        case GET_QUALIFICATION_CATEGORIES.REQUEST: {
            return { ...state, requesting: true, qualificationCategories: false };
        }
        case GET_QUALIFICATION_CATEGORIES.FAIL: {
            return { ...state, requesting: false, qualificationCategories: false };
        }
        case GET_QUALIFICATION_CATEGORIES.SUCCESS: {
            return { ...state, requesting: false, qualificationCategories: action.payload };
        }
        case SET_VIEW_CATEGORY_DETAILS: {
            return { ...state, viewCategoryModalInfo: action.payload };
        }
        default: {
            return state;
        }
    }
};
